export default __webpack_public_path__ + "static/media/image3.931717f9.jpg";